<template>
  <text-input :label="label" :value="value" autocomplete="postal-code"
              :required="required" :min-length="minLength" :max-length="maxLength"
              :input-name="calculatedInputName" :input-id="calculatedInputId"
              :show-label="showLabel" :validation-errors="validationErrors"
              @changed="changed" @focus="$emit('focus')" />
</template>

<script>
import TextFieldMixin from './mixins/text-field-mixin'

export default {
  mixins: [ TextFieldMixin ],

  props: {
    label: {
      type: String,
      required: true
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  emits: ['focus'],

  data() {
    return {
      fieldName: 'postcode'
    }
  }
}
</script>
